export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10983.aaf447c0.jpg";